import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjDownload"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.9122 14.2112L14.5893 10.3333C14.7854 10.1272 14.9081 9.8576 14.9081 9.55854C14.9081 8.9164 14.3586 8.39574 13.681 8.39574C13.6638 8.39574 13.6471 8.39689 13.6304 8.39804C13.623 8.39855 13.6155 8.39906 13.6081 8.39947V8.39014H11.9999V2H7.99995V8.39014H6.34701V8.39747C6.34295 8.39735 6.3389 8.39706 6.33485 8.39676C6.32961 8.39638 6.32435 8.396 6.31901 8.396C5.64155 8.396 5.09195 8.91654 5.09195 9.55854C5.09195 9.8576 5.21448 10.1273 5.40675 10.3361L9.09155 14.2088C9.31595 14.4447 9.63795 14.5964 9.99995 14.5964C10.3619 14.5964 10.6841 14.4447 10.9122 14.2112ZM2.30769 16.1334C2.13776 16.1334 2 16.2711 2 16.4411V17.6923C2 17.8623 2.13776 18 2.30769 18H17.6923C17.8622 18 18 17.8623 18 17.6923V16.4411C18 16.2711 17.8622 16.1334 17.6923 16.1334H2.30769Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var SJ_download = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_download as default };
